var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "MainMenuView",
    {
      attrs: { title: _vm.title, containerClass: "container-fluid" },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("Codes", {
        attrs: {
          title: _vm.title,
          typesToShow: _vm.typesToShow,
          byConditions: _vm.byConditions,
          settingsToShow: _vm.settingsToShow,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }